import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { MainContent, Nav, applicantsTable, savedTable, contactedTable } from "./style";
import Applicants from "./Applicants";
import Saved from "./Saved";
import Contacts from "./Contacts";
import { getAllAplicants } from "../../../redux/middleware/job";

let applicantsTableStyles = { ...applicantsTable };
let savedTableStyles = { ...savedTable };
let contactedTableStyles = { ...contactedTable };

const onclick = (event) => {
  const links = document.querySelectorAll("nav.nav a");
  for (let i = 0, len = links.length; i < len; i += 1) {
    links[i].classList.remove("active");
  }
  const classList = event.currentTarget.classList;
  classList.add("active");

  if (classList.contains("active")) {
    if (classList.contains("saved")) {
      applicantsTableStyles = { ...applicantsTableStyles, display: "none" };
      savedTableStyles = { ...savedTableStyles, display: "block" };
      contactedTableStyles = { ...contactedTableStyles, display: "none" };
    } else if (classList.contains("applicants")) {
      applicantsTableStyles = { ...applicantsTableStyles, display: "block" };
      savedTableStyles = { ...savedTableStyles, display: "none" };
      contactedTableStyles = { ...contactedTableStyles, display: "none" };
    } else {
      applicantsTableStyles = { ...applicantsTableStyles, display: "none" };
      savedTableStyles = { ...savedTableStyles, display: "none" };
      contactedTableStyles = { ...contactedTableStyles, display: "block" };
    }
  }
};

const Candidates = ({ getAllAplicants, user }) => {

  useEffect(() => {
    user && getAllAplicants(user)
  }, [user]);

  return (
    <>
      <Nav className="nav">
        <li className="nav__list">
          <a
            className="active nav__link applicants"
            onClick={onclick}
            href="#/#"
          >
            Applicants
          </a>
        </li>
        <li>
          <a onClick={onclick} href="#/#" className="nav__link saved">
            Saved
          </a>
        </li>
        <li>
          <a onClick={onclick} href="#/#" className="nav__link contacted">
            Contacted
          </a>
        </li>
      </Nav>
      <MainContent>
        <Applicants styles={applicantsTableStyles} />
        <Saved styles={savedTableStyles} />
        <Contacts styles={contactedTableStyles} />
      </MainContent>
    </>
  );
};

const mapStateToProps = (state) => ({
  applicants: state.applicants.applicants,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllAplicants,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Candidates);
